module.exports = __webpack_public_path__ + "static/media/back_btn.1dd11054.svg";